import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

const kycSearchSchema = z.object({
  kyc_status: z.string().optional(),
  search: z.coerce.string().optional(),
  page: z.union([z.string(), z.number()]).optional(),
  limit: z.union([z.string(), z.number()]).optional(),
});

export const kycRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/kyc',
  validateSearch: kycSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/kyc/kyc-page')),
});
